<template>
  <b-overlay :show="loading"
             spinner-variant="primary"
             spinner-type="grow">

    <div class="cont-steps container">
      <div>
        <header class="text-center mb-4">
          <img alt="SGR Luce & Gas" src="../assets/images/logo.svg">
        </header>

        <div class="cont-message bg-azure-gradient mx-auto">
          <div class="h5-bold-white">Grazie</div>
          <div class="h5-regular-white">Il resoconto del tuo check-up energetico è in viaggio verso la tua casella
            email
          </div>
          <a href="/" class="button-blue-100-rounded mt-4">Grazie</a>
        </div>
      </div>
    </div>

  </b-overlay>
</template>

<script>
export default {
  name: 'MessageSent',
  metaInfo: {
    title: 'Check-Up Energetico - SGR Servizi Gas e Luce',
    meta: [
      {
        name: 'description',
        content: 'Scopri i vantaggi di passare a SGR Luce e Gas. Personalizza con noi la tua energia!'
      }
    ]
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
header {
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: -150px;

  img {
    height: 90px;
  }
}

.cont-steps {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  height: calc(var(--vh, 1vh) * 100);

  & > div {
    width: 100%;
  }
}

.cont-message {
  padding: 40px 30px;
  width: 460px !important;
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  text-align: center;
}
</style>
